import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, SMALL_MARGIN } from '../../../../theme';

const useStyles = (lines) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        padding: 24,
        background: colorsPalette.violetAnalyticsCard,
        borderRadius: 10,
        height: 338,
        display: 'flex',
        flexDirection: 'column',
        marginBottom: SMALL_MARGIN,
        '& $cardLabel': {
          marginBottom: SMALL_MARGIN / 2,
          [theme.breakpoints.up('md')]: {
            marginBottom: SMALL_MARGIN,
          },
        },
      },
      infoWrapper: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        overflow: 'hidden',
      },
      cardLabel: {},
      categoryLabel: {
        '& > p': {
          maxWidth: 104,
        },
      },
      title: {
        color: colorsPalette.white,
        fontWeight: 'bold',
        fontSize: 24,
        lineHeight: '28px',
        marginBottom: SMALL_MARGIN / 2,
      },
      description: {
        color: colorsPalette.gray,
        fontSize: 18,
        lineHeight: '24px',
        display: '-webkit-box',
        overflow: 'hidden',
        'white-space': 'inherit',
        textOverflow: 'ellipsis',
        '-webkit-box-orient': 'vertical',
        '-webkit-line-clamp': lines,
      },
      link: {
        marginTop: SMALL_MARGIN / 2,
        color: colorsPalette.violet,
        fontSize: 18,
        lineHeight: '24px',
        '&:hover': {
          textDecoration: 'underline',
        },
      },
    }),
  );

export default useStyles;
